import "../css/app.scss";

import Accordion from "./components/accordion";
import Header from "./components/header";
import Burger from "./components/burger";

$(() => {
  $(".accordion").each((_, el) => {
    new Accordion($(el));
  });

  const $header = $("header");
  if ($header.length) {
    new Header($header);
  }

  const $burger = $('[data-burger="el"]');
  new Burger($burger);
});
